'use client'

import { GetProfileSetsResponse, ProfileSet } from '@/server/services/types'
import { PropsWithChildren, createContext, use, useContext } from 'react'

type BlendVisionContextType = {
  profileSets: ProfileSet[]
}

type BlendVisionProviderProps = PropsWithChildren<{
  profileSetsPromise: Promise<GetProfileSetsResponse>
}>

const BlendVisionContext = createContext<BlendVisionContextType | null>(null)

export function BlendVisionProvider({ children, profileSetsPromise }: BlendVisionProviderProps) {
  const profileSets = use(profileSetsPromise).profile_sets

  return (
    <BlendVisionContext.Provider
      value={{
        profileSets,
      }}
    >
      {children}
    </BlendVisionContext.Provider>
  )
}

export const useBlendVisionContext = () => {
  const value = useContext(BlendVisionContext)

  if (value == null) {
    throw new Error('useBlendVisionContext cannot be used outside of BlendVisionProvider')
  }

  return value
}
